function extensionPreview(ext) {
    let extension = ext && ext.split('.').pop().toUpperCase()
    const documentTypes = ['PDF', 'DOC', 'DOCX', 'PPT', 'PPTX', 'XLS', 'XLSX', 'EPUB', 'ODT', 'ODP', 'ODS', 'TXT', 'RTF'];
    const imageTypes = ['BMP', 'PNG', 'JPG', 'JPEG', 'GIF', 'SVG', 'TIFF', 'EPS'];
    const audioTypes = ['WAV', 'MP3', 'WMA', 'FLAC', 'ALAC', 'PCM', 'AIFF', 'ACC', 'OGG'];
    const videoTypes = ['MPG', 'MPEG', 'MOV', 'MP4', 'AVI', 'WMV', 'FLV', 'SWF', 'WEBM', 'MPE', 'MPV', 'MP2', 'OGG', 'mp4', 'M4V', 'QT'];
    const zipTypes = ['ZIP', 'CAB', 'BIN', 'JAR', 'TAR', 'WAR', 'RAR', '7Z', 'GZ'];

    if (documentTypes.includes(extension)) {
        return 'file alternate'
    }
    if (imageTypes.includes(extension)) {
        return 'image'
    }
    if (audioTypes.includes(extension)) {
        return 'microphone'
    }
    if (videoTypes.includes(extension)) {
        return 'video'
    }
    if (zipTypes.includes(extension)) {
        return 'file archive'
    }
    return 'file';
};

export default extensionPreview;